import { Flex, Text } from "@chakra-ui/react";
import moment from "moment-timezone";
import { DueDateCellProps } from "../types";

export function DueDateCell({ dueDate, textColor }: DueDateCellProps) {
  return (
    <Flex align="center">
      <Text
        color={textColor}
        fontSize="14px"
        lineHeight="24px"
        fontWeight="400"
      >
        {dueDate
          ? moment(new Date(dueDate)).format("MM/DD/YY")
          : "-"}
      </Text>
    </Flex>
  );
}
